import Polygon = require("esri/geometry/Polygon");
import Graphic = require("esri/Graphic");
import SimpleFillSymbol = require("esri/symbols/SimpleFillSymbol");
import Draw = require("esri/views/draw/Draw");
import MapView = require("esri/views/MapView");
import ToolBar from "./../Toolbar";
import ToolButton from "./toolButton";
import { clearGraphicType } from "../App/setupView";
import GraphicsLayer = require("esri/layers/GraphicsLayer");

// ZoomOutTool

export default class ZoomOutTool extends ToolButton {
  private draw: Draw;
  private drawLayer: GraphicsLayer;

  constructor(viewIn: MapView, toolbarIn: ToolBar) {
    super(viewIn, toolbarIn);
    this.drawLayer = this.view.map.findLayerById("drawLayer") as GraphicsLayer;
    this.draw = new Draw({ view: viewIn });
  }

  deactivateTool() {
    // console.log("measureDistanceTool deactivateTool")
    document.body.style.cursor = "default";
    clearGraphicType(this.view, "zoom");
    if (this.draw && this.draw.view && this.draw.activeAction) {
      // if action is active, drawing was never completed, clear graphic
      this.draw.reset();
    }
  }

  // Put widgets on map view
  activateTool(event: any) {
    // console.log("zoomOutTool start")
    try {
      this.iconDiv = event.currentTarget;

      if (this.toolbar) {
        this.toolbar.setActiveTool(this as ToolButton);
      }
      if (this.view) {
        // create an instance of draw polyline action
        // the polyline vertices will be only added when
        // the pointer is clicked on the view
        const action = this.draw.create("rectangle");
        this.view.focus();
        document.body.style.cursor = "crosshair";

        action.on("vertex-add", ({ vertices }) => this.drawPolygon(vertices));
        action.on("cursor-update", ({ vertices }) => this.drawPolygon(vertices));
        action.on("vertex-remove", ({ vertices }) => this.drawPolygon(vertices));
        action.on("redo", ({ vertices }) => this.drawPolygon(vertices));
        action.on("undo", ({ vertices }) => this.drawPolygon(vertices));
        action.on("draw-complete", ({ vertices }) => {
          // console.log("zoomOutTool Complete");
          clearGraphicType(this.view, "zoom");

          const rect = this.createRectangle(vertices);
          if (rect) {
            const polygon = new Polygon({
              rings: rect,
              spatialReference: this.view.spatialReference
            });
            const sizeRatio = Math.max(
              this.view.extent.width / polygon.extent.width,
              this.view.extent.height / polygon.extent.height
            );
            // console.log("ZoomOut SizeRatio = ", sizeRatio);
            const outExtent = polygon.extent.expand(sizeRatio * 4); // Try to duplicate ArcMap zoom out by rectangle
            this.view.goTo({ geometry: outExtent });
          }
          this.draw.reset();
          this.toolbar.setPanAsActiveTool();
        });
      }
    } catch (error) {
      console.error("Error: in zoomOutTool " + +error.message);
    }
  }

  private createRectangle(vertices: any) {
    if (vertices && vertices.length === 2) {
      // create a new polygon
      const rect: any = [];
      rect.push(vertices[0]);
      rect.push([vertices[0][0], vertices[1][1]]);
      rect.push(vertices[1]);
      rect.push([vertices[1][0], vertices[0][1]]);
      return rect;
    } else {
      return null;
    }
  }

  private drawPolygon(vertices: any) {
    // remove existing graphic
    clearGraphicType(this.view, "zoom");
    const rect = this.createRectangle(vertices);
    if (rect) {
      // create a new polygon
      const polygon = new Polygon({
        rings: rect,
        spatialReference: this.view.spatialReference
      });

      // create a new graphic representing the polygon, add it to the view
      const graphic = new Graphic({
        geometry: polygon,
        attributes: { type: "zoom" },
        symbol: new SimpleFillSymbol({
          color: [178, 102, 234, 0.8],
          style: "solid",
          outline: {
            // autocasts as SimpleLineSymbol
            color: [255, 255, 255],
            width: 2
          }
        })
      });
      this.drawLayer.add(graphic);
    }
  }
}
